module.exports = "/_next/static/images/71b20894fe093af68e1ae38edbc3b249-pen@desktop1024.jpg";